import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useParams, useLocation } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { useCookies } from "react-cookie";
import Login from './screens/Login';
import Signup from './screens/Signup';
import ResetPassword from './screens/ResetPassword';
import ChangePassword from './screens/ChangePassword';
import Dashboard from './screens/Dashboard';
import TostMessageComponent from "./TostMessageComponent/TostMessageComponent";
import ScrollToTop from './screens/ScrollToTop';
import { MenuContext } from './context/MenuContext';

function App() {
  return (
    <div className='bg-[#1e1a14] h-full'>
      {/* Main content */}
      {/* <ScrollToTop /> */}
      <TostMessageComponent />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path='/create-account' element={<Signup />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/change-password' element={<ChangePassword />} />
        <Route path='/dashboard/*' element={<Dashboard />} />
      </Routes>
    </div>
  );
}

export default App;
